// extracted by mini-css-extract-plugin
export default {"wrapper":"customersList_wrapper__RcK0q"};